import { render, staticRenderFns } from "./CheaterStatusView.vue?vue&type=template&id=f0c53fe2&scoped=true&"
import script from "./CheaterStatusView.vue?vue&type=script&setup=true&lang=js&"
export * from "./CheaterStatusView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CheaterStatusView.vue?vue&type=style&index=0&id=f0c53fe2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c53fe2",
  null
  
)

export default component.exports